import { useState } from 'react'
import { getAppointmentById } from '../services/appointments'

export const useGetAppointment = () => {
  const [appointment, setAppointment] = useState()
  const [loading, setLoading] = useState(false)

  const getAppointment = async (id) => {
    try {
      setLoading(true)
      const appointment = await getAppointmentById(id)
      setAppointment(appointment)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    appointment,
    loading,
    getAppointment
  }
}
